import React from "react";

type UsageType = {
    color: string;
    filledAmount: number;
    totalAmount: number;
}

const ProgressBarExtended: React.FC<UsageType> = ({ color, filledAmount, totalAmount }) => {
    const percentageFilled = Math.min(((filledAmount - 1) / (totalAmount - 1)) * 100, 100);

    return (
        <div className="flex justify-center items-center w-full h-full box-border relative flex-col" style={{ fontSize: "1.5vh" }}>
            <div
                className="w-full h-full overflow-hidden flex justify-center items-center box-border flex-col"
                style={{
                    background: `linear-gradient(to right, rgba(${color}, 0.2) 35%, rgba(30, 30, 30, 0.5))`,
                    borderRadius: "0.5vh",
                    padding: "0.5vh 1vh",
                    gap: "0.3vh",
                }}
            >
                <div
                    className="w-full h-full flex justify-center items-center box-border flex-col"
                    style={{
                        backgroundColor: `rgba(${color}, 0.2)`,
                        padding: "0.4vh",
                        borderRadius: "0.25vh",
                    }}
                >
                    <div className="w-full h-full flex justify-center items-center box-border flex-col overflow-hidden" style={{ borderRadius: "0.5vh" }}>
                        <div className="h-full w-full rounded-[inherit] overflow-hidden flex justify-start items-center bg-transparent">
                            <div
                                className="h-full text-right overflow-hidden transition-all duration-200 ease-in-out"
                                style={{
                                    width: `${percentageFilled}%`,
                                    background: `rgba(${color}, 1)`,
                                    filter: `drop-shadow(0 0 1vh rgba(${color}, 1))`,
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="w-full flex justify-between items-center box-border font-normal tracking-normal" style={{ height: "40%" }}>
                    {Array.from({ length: totalAmount }).map((_, index) => {
                        const value = index + 1;
                        return (
                            <span
                                key={value}
                                className="transition-colors duration-200"
                                style={{
                                    color: filledAmount >= value ? `rgba(${color}, 1)` : "rgba(255, 255, 255, 0.8)",
                                }}
                            >
                                {value}
                            </span>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ProgressBarExtended;
